// Rich-Text block schema - Simple text section
export const richTextSchema = {
  type: 'rich-text',
  label: 'Text Section',
  description: 'Simple text section with heading and rich text content',
  icon: 'Type',
  defaultContent: {
    heading: '',
    body: 'Add your content here...',
    alignment: 'center', // 'left' | 'center' | 'right'
    maxWidth: 'normal', // 'narrow' | 'normal' | 'wide'
    headingSize: 'medium', // 'small' | 'medium' | 'large' | 'xlarge'
    style: {},
  },
  fields: [
    { name: 'heading', label: 'Heading (optional)', type: 'text', placeholder: 'Enter heading...' },
    {
      name: 'headingSize',
      label: 'Heading Size',
      type: 'select',
      options: [
        { value: 'small', label: 'Small' },
        { value: 'medium', label: 'Medium' },
        { value: 'large', label: 'Large' },
        { value: 'xlarge', label: 'Extra Large' },
      ],
    },
    { name: 'body', label: 'Content', type: 'richtext', placeholder: 'Enter content...' },
    {
      name: 'alignment',
      label: 'Text Alignment',
      type: 'select',
      options: [
        { value: 'left', label: 'Left' },
        { value: 'center', label: 'Center' },
        { value: 'right', label: 'Right' },
      ],
    },
    {
      name: 'maxWidth',
      label: 'Content Width',
      type: 'select',
      options: [
        { value: 'narrow', label: 'Narrow' },
        { value: 'normal', label: 'Normal' },
        { value: 'wide', label: 'Wide' },
      ],
    },
  ],
};
